import comp from "./SchoolInfo";
export default comp;
